import { render, staticRenderFns } from "./StocksViewStockForm.vue?vue&type=template&id=f1f0a15a"
import script from "./StocksViewStockForm.vue?vue&type=script&lang=js"
export * from "./StocksViewStockForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports